import {plpViewMenu} from "./plp-header";
import {featureBanner} from "./plp-product-grid";
import {accordion} from "./plp-sidebar/accordion";
import {productFilters} from "./plp-sidebar/productFilters";
import {nestedCheckbox} from "./plp-sidebar/nestedCheckbox";
import {postcodePopup} from "./popup-postcode";
import {pTiles} from "./product-tile";

function reportError(e) {
  try {
    console.error(e);
    window.Raven && window.Raven.captureException(e);
  } catch(e2) {
    console.error(e2);
  }
}

const initJSFromRelab = () => {
  try { plpViewMenu().init(); } catch (e) { reportError(e); }
  try { featureBanner().init(); } catch (e) { reportError(e); }
  try { accordion().init(); } catch (e) { reportError(e); }
  try { productFilters().init(); } catch (e) { reportError(e); }
  try { nestedCheckbox().init(); } catch (e) { reportError(e); }
  try { postcodePopup().init(); } catch (e) { reportError(e); }
  try { pTiles().init(); } catch (e) { reportError(e); }
};

export default initJSFromRelab;
